<cb-dialog [dialogHeading]="'Progress Payment Version History'">
    <form>
        <cb-table
            class="cb-margin-top"
            label="progress payment history entries"
            [loaded]="paymentHistoryItems !== undefined"
            [stringColumns]="displayedColumns"
            [minWidth]="750"
        >
            <tbody cbTableBody>
                @for (payment of paymentHistoryItems; track payment) {
                    <tr cbTableRow>
                        @if (payment.buildStageId) {
                            <cb-td-text [value]="payment.buildStageLabel"> </cb-td-text>
                        }
                        @if (!payment.buildStageId) {
                            <cb-td-enum [value]="payment.trigger" [enum]="BUILD_STAGE_EVENT_ENUM">
                            </cb-td-enum>
                        }
                        <td>{{ payment.previousDollarValue | cbCurrency }}</td>
                        <td>{{ payment.dollarValue | cbCurrency }}</td>
                        <cb-td-text
                            [value]="payment.createdDate | date: 'dd MMM yyyy hh:mm a'"
                        ></cb-td-text>
                        <cb-td-text [value]="payment.createdByName"></cb-td-text>
                        <cb-td-text [value]="payment.changeReasonDescription"></cb-td-text>
                    </tr>
                }
            </tbody>
        </cb-table>
    </form>
    <div actions>
        <button mat-raised-button (click)="closeDialog()">Close</button>
    </div>
</cb-dialog>
